import { useState } from 'react';

type Position = {
  x: number;
  y: number;
  top: number;
  maxHeight: number;
};

export function useDropdownPosition(
  menuHeight: number,
  margin: number = 5,
  align: 'left' | 'right' = 'right',
) {
  const [position, setPosition] = useState<Position | undefined>();
  const [below, setBelow] = useState(true);

  const calculatePosition = (ref: React.RefObject<HTMLElement>) => {
    if (!ref.current) {
      return;
    }
    const rect = ref.current.getBoundingClientRect();
    const x = align === 'left' ? rect.left : rect.right;
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;

    const canShowBelow = spaceBelow >= menuHeight;
    const canShowAbove = spaceAbove >= menuHeight;

    const isBelow = canShowBelow || (!canShowAbove && spaceBelow >= spaceAbove);
    const maxHeight = isBelow
      ? Math.min(menuHeight, spaceBelow - margin * 2)
      : Math.min(menuHeight, spaceAbove - margin * 2);

    const y = isBelow ? rect.bottom + margin : Math.max(margin, rect.top - maxHeight - margin);

    setBelow(isBelow);
    setPosition({ x, y, top: rect.top, maxHeight });
  };

  return { position, below, calculatePosition };
}
